<template>
	<div class="harness">
		<div class="harness-bar">
			<strong>Package Offer — local styling fixture</strong>
			<label>Brand kit <select v-model="kit"><option value="studio">Studio fixture</option><option value="minimal">Minimal fixture</option><option value="none">No kit</option></select></label>
			<label>Appearance <select v-model="appearance"><option value="legacy">Legacy</option><option value="light">Light</option><option value="dark">Dark</option><option value="both">Both</option></select></label>
			<label>Layout <select v-model="item.definition.presentation.layout"><option>CARDS</option><option>STACKED</option><option>COMPARISON</option></select></label>
			<label>Selection <select v-model="item.definition.selectionRules.mode"><option value="FIXED">Everything included</option><option value="CHOOSE_ONE">Choose one</option><option value="CHOOSE_MANY">Choose multiple</option></select></label>
			<label><input v-model="nonDecisionSigner" type="checkbox" /> Non-decision signer</label>
			<label><input v-model="locked" type="checkbox" /> Locked selection</label>
			<p>Mock quote for layout only. Amounts do not recalculate. No API, signing or payments.</p>
		</div>
		<v-theme-provider :dark="effectiveAppearance === 'dark'" :light="effectiveAppearance === 'light'">
		<main id="print-area" :class="{ 'brand-agreement': branding }" :style="brandStyle">
			<PackageOffer :key="`${locked}:${item.definition.selectionRules.mode}`" :item="offer" :agreement="agreement" :viewer-service="viewerService" />
			<Signature :agreement="agreement" :item="signature" :signer="viewer" />
		</main>
		</v-theme-provider>
	</div>
</template>

<script>
	import { agreementBranding, invoiceBrandStyle, cloneBranding, DEFAULT_BRANDING } from '@moxie/branding';
	import { documentBrandAppearance, resolveDocumentBranding } from '@/utils/portalBranding';
	import '@moxie/branding/src/agreement.scss';
	import PackageOffer from '@/modules/agreements/schema/PackageOffer.vue';
	import Signature from '@/modules/agreements/schema/Signature.vue';
	import { packageOffer, authoritativeQuote } from '../../../tests/fixtures/agreementPackageOffers';

	export default {
		components: { PackageOffer, Signature },
		data() {
			const item = packageOffer();
			item.definition.presentation.title = 'Votre prochain chapitre';
			item.definition.presentation.descriptionHtml = '<p>Un accompagnement adapté à votre entreprise.</p><h3>Une offre claire</h3>';
			item.definition.presentation.addOnsLabel = 'Options supplémentaires';
			item.definition.presentation.paymentChoiceLabel = 'Mode de paiement';
			item.definition.presentation.chooseOptionLabel = 'Choisir cette option';
			item.definition.presentation.selectedOptionLabel = 'Votre choix';
			item.definition.defaultSelection.addOns = [{ addOnId: 'global-training', quantity: 1 }];
			return {
				kit: 'studio',
				appearance: 'legacy',
				locked: false,
				nonDecisionSigner: true,
				item,
				signature: { id: 'signature-fixture', signedBy: [], pt: 8, pb: 8, pl: 16, pr: 16 },
				signers: [
					{ id: 'decision-maker', firstName: 'Alex', lastName: 'Rivera', signerType: 'CLIENT', locked: false },
					{ id: 'other-signer', firstName: 'Jamie', lastName: 'Chen', signerType: 'CLIENT', locked: false },
				],
				viewerService: { quotePackageOffer: (selection) => Promise.resolve({ data: authoritativeQuote(selection) }) },
			};
		},
		computed: {
			effectiveAppearance() {
				return documentBrandAppearance(this.rawBranding, this.$vuetify.theme.dark ? 'dark' : 'light');
			},
			rawBranding() {
				if (this.kit === 'none') return null;
				const branding = cloneBranding(DEFAULT_BRANDING);
				branding.colors.primary = '#6D28D9';
				branding.colors.surface = '#F5F3FF';
				branding.typography.bodyFamily = 'Arial';
				branding.typography.headingFamily = 'Georgia';
				branding.typography.h2Family = 'Georgia';
				branding.typography.h3Family = 'Courier New';
				branding.typography.h2Size = 30;
				branding.typography.h3Size = 22;
				branding.surfaces.radius = this.kit === 'minimal' ? 0 : 24;
				branding.fields.radius = 4;
				branding.buttons.radius = 18;
				if (this.kit === 'minimal') branding.colors.surface = '#FFFFFF';
				if (this.appearance !== 'legacy') branding.appearance = this.appearance;
				return branding;
			},
			agreement() {
				return {
					id: 'styling-fixture',
					branding: resolveDocumentBranding(this.rawBranding, this.effectiveAppearance),
					account: { enableGeoLocationOnSignature: false },
					client: { name: 'Fixture client' },
					signers: this.signers,
					styles: { pageSize: 'RESPONSIVE' },
					pages: [{ schema: [this.offer] }],
				};
			},
			viewer() { return this.nonDecisionSigner ? this.signers[1] : this.signers[0]; },
			branding() { return agreementBranding(this.agreement); },
			brandStyle() { return invoiceBrandStyle(this.branding); },
			offer() {
				return {
					...this.item,
					commercialState: {
						canEditSelection: !this.nonDecisionSigner && !this.locked,
						selectionLocked: this.locked,
						decisionSignerName: 'Alex Rivera',
					},
					acceptedSelection: this.item.definition.defaultSelection,
				};
			},
		},
	};
</script>

<style scoped>
	.harness { min-height: 100vh; background: #eeeeee; }
	.harness-bar { display: flex; flex-wrap: wrap; align-items: center; gap: 14px; padding: 14px; background: #17211e; color: white; }
	.harness-bar p { flex-basis: 100%; margin: 0; }
	.harness-bar select { background: white; color: #17211e; padding: 4px; }
	main { max-width: 1100px; margin: 0 auto; background: var(--brand-background, white); text-align: left; }
	@media print { .harness-bar { display: none; } }
</style>
